module.exports = __webpack_public_path__ + "img/p2_l.56a1a22f.jpg";